import React from 'react'
import { Flex, Grid, GridProps, Heading } from '@chakra-ui/react'
import { BlogCard, BlogCardData } from 'containers/blogs/components/BlogCard'

export const RelatedBlogs = ({
    blogs,
    ...props
}: { blogs?: BlogCardData[] } & Pick<GridProps, 'gridTemplateColumns'>) => {
    const { gridTemplateColumns } = props

    return (
        <Flex direction="column" gridGap="16px">
            <Heading size="sm">Related articles</Heading>
            <Grid
                gridTemplateColumns={gridTemplateColumns}
                gridGap="20px"
                h="fit-content"
            >
                {[0, 1].map(idx => {
                    const blog = blogs && blogs[idx]
                    return <BlogCard key={blog?.id || idx} blog={blog} />
                })}
            </Grid>
        </Flex>
    )
}
